@if (products()?.length) {
  <div class="cross-sell">
    <div class="cross-sell-title-container">
      <span class="cross-sell-title">
        {{ 'cross_sell_products.together_bought' | translate }}:
      </span>
    </div>
    <products-preview
      [items]="products()"
      [parentNameForAnalytics]="sourceForAnalytics"
      (showCart)="showCart.emit($event)"
    />
  </div>
}
